import { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppConfigs from 'general/constants/AppConfigs';

// Global variables
const Global = {
  // ---- filters ----
  g_filterChargeTransactionList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    from: '',
    to: '',
    selectedValue: '',
    status: '',
    stationId: '',
  },
  g_filterChargePointList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    type: '',
    stationId: '',
    vehicleType: '',
    chargingSpeed: '',
    operatorId: '',
    managementObject: '',
    agencyId: '',
    landlordId: '',
  },
  g_filterPaymentTransactionList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    dateFilter: dateFilter.baMuoiNgayGanNhat,
    from: '',
    to: '',
  },
  g_filterDealerList: {
    role: 'SALE',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    parentAgencyId: '',
    createdBy: '',
    deepLevel: '',
    hasSignedContract: '',
  },
  g_filterSubAgenciesList: {
    role: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    createdBy: '',
    deepLevel: '',
    hasSignedContract: '',
  },
  g_filterStaffList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    agencyId: '',
    role: '',
    status: '',
  },
  g_filterLandownerList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    role: 'LANDLORD',
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    parentAgencyId: '',
    createdBy: '',
    deepLevel: '',
  },
  g_filterInvestorList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    role: 'INVESTOR',
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    parentAgencyId: '',
    createdBy: '',
    deepLevel: '',
    hasSignedContract: '',
  },

  g_filterInvestorGroupList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    role: 'GROUP',
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    parentAgencyId: '',
    createdBy: '',
    deepLevel: '',
    hasSignedContract: '',
  },
  g_filterChargePointPartnerList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    role: 'CHARGEPOINT',
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    parentAgencyId: '',
    createdBy: '',
    deepLevel: '',
    hasSignedContract: '',
  },
  g_filterPaymentDepositList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    status: '',
    dateFilter: dateFilter.baMuoiNgayGanNhat,
    from: '',
    to: '',
  },
  g_filterCommissionTransactionList: {
    agencyId: '',
    q: '',
    selectedValue: '',
    from: '',
    to: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    forRole: '',
    direction: 'IN',
  },
  g_filterAgencyTransactionList: {
    agencyId: '',
    q: '',
    from: '',
    to: '',
    status: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    forRole: '',
    type: '',
  },
  g_filterElectricityPaymentList: {
    agencyId: '',
    q: '',
    from: '',
    to: '',
    status: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    forRole: '',
    type: '',
  },
  g_filterSaleReconciliationList: {
    forRole: 'SALE',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    month: moment().subtract(1, 'months').format('YYYY-MM'),
  },
  g_filterInvestorReconciliationList: {
    forRole: 'INVESTOR',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    month: moment().subtract(1, 'months').format('YYYY-MM'),
  },
  g_filterGroupReconciliationList: {
    forRole: 'GROUP',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    month: moment().subtract(1, 'months').format('YYYY-MM'),
  },
  g_filterLandlordReconciliationList: {
    forRole: 'LANDLORD',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    month: moment().subtract(1, 'months').format('YYYY-MM'),
  },
  g_filterPremisesList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    areaId: '',
    type: '',
    vehicleTypes: '',
    rentingType: '',
    rentalForm: '',
    status: '',
    contractStatus: '',
    free: '',
    landlordId: '',
  },
  g_filterTutorialsList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    status: '',
    for: 'DRIVER',
  },
  g_filterChargeInventoryList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    q: '',
    brandId: '',
  },
  g_filterMaintainerList: {
    page: 0,
    limit: AppConfigs.defaultPageLimit,
    operatorId: '',
    status: '',
    type: '',
    from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
    to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    selectedValue: dateFilter.tatCaThoiGian,
    areaId: '',
    q: '',
    createdBy: '',
    hasSignedContract: '',
    country: '',
  },
};

export default Global;
